// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__1tW1-","input":"Input_input__16GTR","label":"Input_label__DXGh8","erro":"Input_erro__3O2JN","checkmark":"Input_checkmark__8u9Fc"};